
import { Options, Vue } from "vue-class-component";
import ScheduleCardByHour from "./ScheduleCardByHour.vue";
import { searchFilter } from "../data/functions";
import { useStore } from "../store";

@Options({
  components: {
    ScheduleCardByHour,
  },
  props: {
    hour: Number,
  },
  methods: {
    // returns the events that have the same start hour as the hour displayed on the bar
    filteredEvents() {
      return searchFilter(this.store.state.searchResults, "schedule")
        .filter(
          (event: { showStartDate: Date }) =>
            new Date(event.showStartDate).getHours() ===
            new Date(this.hour).getHours()
        )
        .sort(
          (a: { showStartDate: Date }, b: { showStartDate: Date }) =>
            new Date(a.showStartDate).getMinutes() -
            new Date(b.showStartDate).getMinutes()
        );
    },
  },
})
export default class ScheduleByHourGrid extends Vue {
  store = useStore();
  searchFilter = searchFilter;
  hour!: number;
}
